import { useContext } from "react"
import { ProjectContext } from "./project.context";

export const useProject = () => {
    const context = useContext(ProjectContext)
    if (context === undefined){
        throw new Error(`Component is not inside ProjectContext scope`);
    }
    return context
}